/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Macro_FatInputs */

const en_portal_macro_fat = /** @type {(inputs: Portal_Macro_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fat`)
};

const pl_portal_macro_fat = /** @type {(inputs: Portal_Macro_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tłuszcze`)
};

/**
* | output |
* | --- |
* | "Fat" |
*
* @param {Portal_Macro_FatInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_macro_fat = /** @type {((inputs?: Portal_Macro_FatInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Macro_FatInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_macro_fat(inputs)
	return en_portal_macro_fat(inputs)
});